// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Debug_wrapper","dump-values":"Debug_dump-values","dumpValues":"Debug_dump-values"};